import React from 'react'

const LandingPage = () => {
  return (
    <div className='h-100 d-flex justify-content-center align-items-center'>
      <h3 className='fw-bold h1'>WELCOME TO <br></br> PAYROLL MANAGEMENT</h3>
    </div>
  )
}

export default LandingPage
